/* eslint-disable-next-line import-x/prefer-default-export */
export const NOTIFICATION_TYPES = {
  email: 'Email',
  grafana: 'Grafana',
  irc: 'IRC',
  mattermost: 'Mattermost',
  pagerduty: 'Pagerduty',
  rocketchat: 'Rocket.Chat',
  slack: 'Slack',
  twilio: 'Twilio',
  webhook: 'Webhook',
};
